import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MGrid, MSpinner } from "components/Shared";
import { getAssignedCases } from "requests/inspectorCases";
import { clearNullFromColumnDefs } from "components/Shared/Functions";
import { updateHeader, clearHeader } from "actions/layout";

const FieldRepOrderQueue = ({ location, history, updateHeader, clearHeader }) => {
  const [assignedCases, setAssignedCases] = useState(null);

  const mounted = useRef(true);

  useEffect(() => {
    if (location?.state?.inspectorId) {
      getAssignedCases(location.state.inspectorId, setAssignedCases, mounted);
    } else {
      history.push("/");
    }

    updateHeader({
      buttons: [{
        name: "Go Back",
        onClick: () => history.goBack(),
      }]
    });

    return () => {
      mounted.current = false;
      clearHeader();
    };
  }, []);

  const onCaseClicked = index => {
    history.push({
      pathname: "/case",
      state: {
        controlNumber: assignedCases.rows[index].controlIdNumber,
      }
    });
  };

  if (!assignedCases) return <MSpinner />;
  
  return (
    <div className="padding-page-content full-height">
      <MGrid
        columnDefinitions={clearNullFromColumnDefs(assignedCases.columns)}
        data={assignedCases.rows}
        onRowClick={onCaseClicked}
      />
    </div>
  );
};

FieldRepOrderQueue.propTypes = {
  location: PropTypes.object,
  updateHeader: PropTypes.func,
  clearHeader: PropTypes.func,
  history: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  updateHeader(headerDefinitions) {
    dispatch(updateHeader(headerDefinitions));
  },
  clearHeader() {
    dispatch(clearHeader());
  },
});

export default connect(null, mapDispatchToProps)(FieldRepOrderQueue);
